import styles from './styles.module.scss';

export const Tags = ({ tags, dataTest, tagDataTest }: { tags: string[], dataTest: string, tagDataTest: string }) => (
  <div data-test={ dataTest }>
    { tags.map((tag) => (
      <span className={ styles.tagItem } key={ tag } data-test={ tagDataTest }>{ tag }</span>
    )) }
  </div>
);
